import React, { Component } from 'react';
//import logo from './logo.svg';
import PropTypes from 'prop-types';
import './App.css';
import {Button, Header, Form, Segment} from 'semantic-ui-react'
import { registerUser } from 'react-cognito';

class Register extends Component {
    constructor(props) {
    super(props);
    this.state = {
      error: '',
      email: '',
      password: '',
        };
    }



  render() {
    return (
        <div className="RegisterForm">
            <Segment.Group>
                <Segment color='green'>
                    <Header as='h3' color="green" >Register</Header>
                    
                    <Form id="registerForm" onSubmit={this.handleRegister}>
                        <Form.Field>
                            <Form.Group>
                                <Form.Input fluid type="email" id="emailInputRegister" placeholder="Email" onChange={this.handleEmail} required width={4} />
                                <Form.Input fluid type="password" id="passwordInputRegister1" placeholder="Password" pattern=".*" onChange={this.handlePassword} required width={4} />
                                <Form.Input fluid type="password" id="passwordInputRegister2" placeholder="Confirm Password" pattern=".*" required width={4} />
                                <Form.Button color='green' type="submit">Register</Form.Button>
                            </Form.Group>
                        </Form.Field>
                    </Form>
                </Segment>

                <Segment.Group horizontal>
                    <Segment textAlign='center'>
                        <span className="small text">Already have an account? &nbsp;<Button basic onClick={this.navigateToSignIn}><b>Sign In</b></Button></span>
                    </Segment>
                    <Segment textAlign='center'>
                        <span className="small text">Need to verify your account? &nbsp;<Button basic onClick={this.navigateToVerify}><b>Verify</b></Button></span>
                    </Segment>
                </Segment.Group>

            </Segment.Group>

        </div>

    );
  }

  handleEmail = (event) => {
    this.setState({ email: event.target.value });
  }

  handlePassword = (event) => {
    this.setState({ password: event.target.value });
  }


  handleRegister = (event) => {
      //console.log(this.state.email + "| " + this.state.password);
      const { store } = this.context;
      const state = store.getState();
      const userPool = state.cognito.userPool;
      const config = state.cognito.config;
      event.preventDefault();
      registerUser(userPool, config, this.state.email, this.state.password, {
        email: this.state.email,
      }).then(
        (action) => {
          //store.dispatch(action);
          //this.props.history.push('/');
        },
        error => this.setState({ error }));
    }

    navigateToSignIn = (event) => {
        this.props.changeFunction("SignIn");
    }

    navigateToVerify = (event) => {
        this.props.changeFunction("Verify");
    }


}

Register.contextTypes = {
  store: PropTypes.object,
};

export default Register;



// WEBPACK FOOTER //
// ./src/Register.js